/* Emporium product page behaviour
   - "select size" gate: no size pre-selected; button reads "select size" until one is picked
   - tabs (details / size & fit / shipping)
   - mobile sticky add-to-bag bar
   - drop alert: "Tell me when this drops" on products tagged coming-soon
   - mobile gallery dash indicators
   Works alongside the theme's own product-info.js / product-form.js (no changes to those files). */
(function () {
  if (window.__emporiumPdp) return;
  window.__emporiumPdp = true;

  var SIZE_RE = /^(size|sizes|größe|taille|talla|taglia)$/i;
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function init(root) {
    if (root.dataset.eInit) return;
    root.dataset.eInit = '1';
    var sectionId = root.dataset.section;
    // Has the shopper chosen a size themselves? (A ?variant= link counts as a choice.)
    var userPicked = new URLSearchParams(window.location.search).has('variant');

    function submitBtn() { return root.querySelector('#ProductSubmitButton-' + sectionId); }
    function submitLabel() { var b = submitBtn(); return b ? b.querySelector('span') : null; }

    /* ---------- Size gate ---------- */
    function sizeRadios() {
      var sets = root.querySelectorAll('variant-selects fieldset');
      for (var i = 0; i < sets.length; i++) {
        var legend = sets[i].querySelector('legend');
        var name = legend ? legend.textContent.replace(/[:\s]+$/, '').trim() : '';
        if (SIZE_RE.test(name)) return sets[i].querySelectorAll('input[type="radio"]');
      }
      return null;
    }

    function applyGate() {
      var radios = sizeRadios();
      var btn = submitBtn();
      if (!radios || radios.length < 2 || !btn) return;
      radios.forEach(function (r) { r.checked = false; });
      root.classList.add('e-awaiting-size');
      // Not `disabled`: a disabled button swallows clicks, and we want a click to highlight the sizes.
      btn.setAttribute('aria-disabled', 'true');
      var label = submitLabel();
      if (label) label.textContent = root.dataset.selectSizeLabel || 'Select size';
      syncSticky();
    }

    var hasVariantParam = new URLSearchParams(window.location.search).has('variant');
    var gateWanted = root.dataset.requireSize === 'true' && !hasVariantParam;
    if (gateWanted) {
      applyGate();
    } else if (!hasVariantParam) {
      // Wait until the theme's product-info element is listening for size changes.
      (window.customElements ? customElements.whenDefined('product-info') : Promise.resolve())
        .then(function () { setTimeout(preselectSmallest, 0); });
    }

    // Pre-select the smallest in-stock size (sizes are listed smallest first).
    // A link to a specific variant (?variant=) is always respected.
    function preselectSmallest() {
      var radios = sizeRadios();
      if (!radios || radios.length < 2) return;
      var first = null;
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].classList.contains('disabled') && !radios[i].disabled) { first = radios[i]; break; }
      }
      if (!first || first.checked) return;
      first.checked = true;
      var ev = new Event('change', { bubbles: true });
      ev.ePreselect = true; // not the shopper's choice
      first.dispatchEvent(ev);
    }

    // "Thank you" message after adding to bag (handled in product-form.js)
    root.querySelectorAll('product-form').forEach(function (pf) {
      if (root.dataset.successMessage) pf.dataset.successMessage = root.dataset.successMessage;
      pf.dataset.successMs = root.dataset.successMs || '0';
    });

    // A size was picked: the theme re-renders the button itself; we just drop the gate.
    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('variant-selects input[type="radio"]')) {
        if (!e.ePreselect) userPicked = true;
        root.classList.remove('e-awaiting-size');
        var b = submitBtn();
        if (b) b.removeAttribute('aria-disabled');
        syncSticky();
      }
    });

    // Clicking "select size" (or pressing Enter in the form) highlights the sizes instead of adding.
    // Capture phase, so this runs before the theme's own submit handler.
    root.addEventListener('submit', function (e) {
      if (!root.classList.contains('e-awaiting-size')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      flashSizes();
    }, true);
    root.addEventListener('click', function (e) {
      if (!root.classList.contains('e-awaiting-size')) return;
      if (e.target.closest('.product-form__submit')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        flashSizes();
      }
    }, true);

    function flashSizes() {
      var radios = sizeRadios();
      if (!radios || !radios.length) return;
      var fs = radios[0].closest('fieldset');
      if (fs && MOBILE.matches) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      root.classList.remove('e-flash-sizes');
      void root.offsetWidth;
      root.classList.add('e-flash-sizes');
      setTimeout(function () { root.classList.remove('e-flash-sizes'); }, 800);
      var first = fs && fs.querySelector('input[type="radio"]:not(.disabled)');
      if (first) first.focus({ preventScroll: true });
    }

    /* ---------- Tabs ---------- */
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-e-tab]');
      var close = e.target.closest('[data-e-tabs-close]');
      if (!tab && !close) return;
      var wrap = (tab || close).closest('[data-e-tabs]');
      if (!wrap) return;
      var target = close ? null : tab.dataset.eTab;
      var already = tab && tab.getAttribute('aria-selected') === 'true';
      if (already) target = null; // clicking the open tab closes it
      wrap.querySelectorAll('[data-e-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.eTab === target ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-e-panel]').forEach(function (p) {
        p.hidden = p.dataset.ePanel !== target;
      });
      wrap.classList.toggle('is-open', !!target);
    });

    /* ---------- Drop alert ("Tell me when this drops") ---------- */
    var onDropChange = function () {};
    var drop = root.querySelector('[data-e-drop]');
    var dropBtn = drop && drop.querySelector('[data-e-drop-button]');
    function dropOn() { return !!drop && root.classList.contains('e-drop-on'); }

    function selectedSize() {
      var radios = sizeRadios();
      if (!radios) return '';
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
      return '';
    }

    if (drop) {
      // The block is only rendered on products tagged coming-soon, so it stays on whatever size is picked.
      var form = drop.querySelector('form');
      var input = drop.querySelector('input[type="email"]');
      var errEl = drop.querySelector('[data-e-drop-error]');
      var doneEl = drop.querySelector('[data-e-drop-done]');
      var tagsEl = drop.querySelector('[data-e-drop-tags]');

      var setDrop = function (on) {
        drop.hidden = !on;
        drop.classList.toggle('is-on', on);
        root.classList.toggle('e-drop-on', on);
        if (on) root.classList.remove('e-awaiting-size');
        onDropChange();
      };

      // The theme re-renders the buy buttons when a size is picked; keep them swapped out
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (!event || !event.data || event.data.sectionId !== sectionId) return;
          setDrop(true);
        });
      }

      var showDone = function (msg) {
        doneEl.textContent = msg || drop.dataset.success;
        doneEl.hidden = false;
        if (errEl) errEl.hidden = true;
        drop.classList.add('is-done');
      };
      var showError = function (msg) {
        if (!errEl) return;
        errEl.textContent = msg || drop.dataset.error;
        errEl.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      };

      // Back from a Shopify Customers sign-up (page reloads with #EmporiumDrop-…)
      var posted = drop.querySelector('[data-e-drop-posted]');
      if (posted && form && location.hash === '#' + form.id) {
        setDrop(true);
        showDone(posted.textContent);
      }

      var slug = function (t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };

      var klaviyoKey = function () {
        if (drop.dataset.publicKey) return drop.dataset.publicKey;
        var scripts = document.querySelectorAll('script[src*="klaviyo.com"]');
        for (var i = 0; i < scripts.length; i++) {
          var m = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/);
          if (m) return m[1];
        }
        return '';
      };

      var klaviyoPost = function (path, key, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
      };

      if (form) form.addEventListener('submit', function (e) {
        var email = (input.value || '').trim();
        if (errEl) errEl.hidden = true;
        input.removeAttribute('aria-invalid');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          e.preventDefault();
          input.classList.remove('is-known');
          showError(input.validationMessage || drop.dataset.error);
          input.focus();
          return;
        }
        var size = selectedSize();
        var title = drop.dataset.productTitle;

        // Shopify Customers: add a size tag, then let the form post as normal
        if (tagsEl) tagsEl.value = tagsEl.dataset.base + (size ? ',drop-' + drop.dataset.productHandle + '-size-' + slug(size) : '');
        var key = drop.dataset.provider === 'klaviyo' ? klaviyoKey() : '';
        if (!key) return;

        // Klaviyo: subscribe to the list + record which style (and size) they want
        e.preventDefault();
        dropBtn.setAttribute('aria-busy', 'true');
        dropBtn.disabled = true;
        var source = 'Drop alert: ' + title + (size ? ' (' + size + ')' : '');
        var props = {
          ProductName: title,
          ProductHandle: drop.dataset.productHandle,
          ProductID: drop.dataset.productId,
          URL: drop.dataset.productUrl,
          Size: size || null,
          Status: 'Coming soon'
        };
        var subscription = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: drop.dataset.listId } } }
          }
        };
        var evt = {
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: 'Drop Alert Requested' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              unique_id: drop.dataset.productHandle + ':' + (size || 'any') + ':' + email.toLowerCase()
            }
          }
        };
        Promise.all([klaviyoPost('subscriptions', key, subscription), klaviyoPost('events', key, evt)])
          .then(function () {
            try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
            showDone();
          })
          .catch(function () { showError(); })
          .then(function () { dropBtn.removeAttribute('aria-busy'); dropBtn.disabled = false; });
      });
    }

    /* ---------- Mobile sticky bar ---------- */
    var sticky = root.querySelector('[data-e-sticky]');
    var stickyBtn = sticky && sticky.querySelector('[data-e-sticky-button]');
    var stickyLabel = sticky && sticky.querySelector('[data-e-sticky-label]');
    var stickyPrice = sticky && sticky.querySelector('[data-e-sticky-price]');
    var stickySize = sticky && sticky.querySelector('[data-e-sticky-size]');

    // The size shown in the bar ("Size M"): only once the shopper has picked one themselves
    // (the smallest size is pre-selected on the page, but the bar shouldn't add that without asking).
    function chosenSize() {
      if (!userPicked) return '';
      var radios = sizeRadios();
      if (!radios) return '';
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
      return '';
    }
    function hasSizes() { var r = sizeRadios(); return !!(r && r.length > 1); }
    function anySizeAvailable() {
      var r = sizeRadios();
      if (!r) return false;
      for (var i = 0; i < r.length; i++) if (!r[i].classList.contains('disabled') && !r[i].disabled) return true;
      return false;
    }
    function needsSizeChoice() { return hasSizes() && !userPicked; }

    /* ---------- Size sheet (mobile bar: "which size?") ---------- */
    var sheet = null;
    function sizeSheet() {
      if (sheet) return sheet;
      sheet = document.createElement('div');
      sheet.className = 'e-size-sheet';
      sheet.hidden = true;
      sheet.innerHTML =
        '<div class="e-size-sheet__backdrop" data-e-sheet-close></div>' +
        '<div class="e-size-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ESizeSheetTitle-' + sectionId + '">' +
          '<div class="e-size-sheet__head">' +
            '<p class="e-size-sheet__title" id="ESizeSheetTitle-' + sectionId + '"></p>' +
            '<button type="button" class="e-size-sheet__close" data-e-sheet-close aria-label="Close">' +
              '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="e-size-sheet__grid" data-e-sheet-grid></div>' +
        '</div>';
      root.appendChild(sheet); // inside the product section, so it picks up the Emporium colour & spacing variables
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-e-sheet-close]')) { closeSheet(); return; }
        var b = e.target.closest('[data-e-sheet-size]');
        if (b && !b.disabled) pickFromSheet(b);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
      return sheet;
    }

    function openSheet() {
      var s = sizeSheet();
      var radios = sizeRadios();
      if (!radios) return;
      s.querySelector('.e-size-sheet__title').textContent = root.dataset.selectSizeLabel || 'Select size';
      var grid = s.querySelector('[data-e-sheet-grid]');
      grid.innerHTML = '';
      // One row for up to 6 sizes (like the picker on the page); wider ranges wrap in rows of 4
      grid.style.setProperty('--e-sheet-cols', radios.length <= 6 ? radios.length : 4);
      Array.prototype.forEach.call(radios, function (r) {
        var soldOut = r.classList.contains('disabled') || r.disabled;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'e-size-sheet__size';
        b.setAttribute('data-e-sheet-size', r.value);
        b.textContent = r.value;
        if (soldOut) {
          b.disabled = true;
          b.setAttribute('aria-label', r.value + ' – sold out');
        }
        grid.appendChild(b);
      });
      s.hidden = false;
      document.documentElement.classList.add('e-sheet-open');
      requestAnimationFrame(function () { s.classList.add('is-open'); });
      var first = grid.querySelector('button:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }

    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('e-sheet-open');
      setTimeout(function () { sheet.hidden = true; }, 220);
      if (stickyBtn) stickyBtn.focus({ preventScroll: true });
    }

    function variantInput() {
      var f = root.querySelector('#product-form-' + sectionId) || root.querySelector('product-form form');
      return f ? f.querySelector('input[name="id"]') : null;
    }

    // Select the size on the page, wait for the theme to swap in that variant, then add it to the bag.
    function pickFromSheet(b) {
      var size = b.getAttribute('data-e-sheet-size');
      var radios = sizeRadios();
      var radio = null;
      for (var i = 0; i < radios.length; i++) if (radios[i].value === size) radio = radios[i];
      if (!radio) return;
      b.setAttribute('aria-busy', 'true');
      userPicked = true;
      var input = variantInput();
      var before = input ? input.value : null;
      var addNow = function () {
        closeSheet();
        syncSticky();
        var btn = submitBtn();
        if (btn && !btn.hasAttribute('disabled')) btn.click();
      };
      if (radio.checked) { addNow(); return; }
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      var started = Date.now();
      (function wait() {
        var inp = variantInput();
        var btn = submitBtn();
        var swapped = inp && inp.value !== before;
        var ready = btn && !btn.hasAttribute('disabled') && !btn.classList.contains('loading');
        if (swapped && ready) { setTimeout(addNow, 50); return; }
        if (Date.now() - started > 4000) { b.removeAttribute('aria-busy'); closeSheet(); syncSticky(); return; }
        setTimeout(wait, 80);
      })();
    }
    var mainInView = true;

    function currentPrice() {
      var p = root.querySelector('#price-' + sectionId + ' .price');
      if (!p) return '';
      var el = p.classList.contains('price--on-sale')
        ? p.querySelector('.price__sale .price-item--sale')
        : p.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    function syncSticky() {
      if (!sticky) return;
      var btn = submitBtn();
      var label = submitLabel();
      var askSize = !dropOn() && needsSizeChoice();
      var nextLabel = dropOn() ? dropBtn.textContent.trim()
        : askSize ? (root.dataset.selectSizeLabel || 'Select size')
        : (label ? label.textContent.trim() : '');
      var nextPrice = currentPrice();
      if (stickyLabel.textContent !== nextLabel) stickyLabel.textContent = nextLabel;
      if (stickyPrice.textContent !== nextPrice) stickyPrice.textContent = nextPrice;
      if (stickySize) {
        var size = chosenSize();
        var nextSize = size ? 'Size ' + size : '';
        if (stickySize.textContent !== nextSize) stickySize.textContent = nextSize;
        stickySize.hidden = !nextSize;
      }
      // Greyed out only when nothing can be added (sold out). Asking for a size isn't "disabled".
      var disabled = dropOn() ? false : askSize ? !anySizeAvailable()
        : (!btn || (btn.hasAttribute('disabled') && !root.classList.contains('e-awaiting-size')));
      sticky.classList.toggle('is-disabled', disabled);
      sticky.classList.toggle('is-asking', askSize);
      sticky.classList.toggle('is-visible', MOBILE.matches && !mainInView);
    }

    if (sticky) {
      stickyBtn.addEventListener('click', function () {
        if (dropOn()) {
          var field = drop.querySelector('input[type="email"]:not(.is-known)');
          drop.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 350);
          return;
        }
        if (needsSizeChoice() || root.classList.contains('e-awaiting-size')) {
          if (anySizeAvailable()) openSheet(); else flashSizes();
          return;
        }
        var btn = submitBtn();
        if (!btn || btn.hasAttribute('disabled')) {
          if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        btn.click();
      });

      // The submit button itself (its wrappers use display: contents, so they have no box to observe)
      var observeTarget = function () { return dropOn() ? dropBtn : submitBtn(); };
      var io = new IntersectionObserver(function (entries) {
        mainInView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
        syncSticky();
      }, { threshold: [0, 0.5, 1] });
      var t = observeTarget();
      if (t) io.observe(t);

      // Keep label and price in step with the theme's re-renders.
      new MutationObserver(function () {
        var nt = observeTarget();
        if (nt && nt !== t) { io.disconnect(); io.observe(nt); t = nt; }
        syncSticky();
      }).observe(root.querySelector('.product__info-wrapper') || root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

      onDropChange = function () {
        var nt = observeTarget();
        if (nt && nt !== t) { io.disconnect(); io.observe(nt); t = nt; }
        syncSticky();
      };

      // A size was picked: update the bar straight away (the theme re-renders the picker a moment later)
      root.addEventListener('change', function (e) {
        if (e.target && e.target.matches('variant-selects input[type="radio"]')) setTimeout(syncSticky, 0);
      });

      MOBILE.addEventListener ? MOBILE.addEventListener('change', syncSticky) : MOBILE.addListener(syncSticky);
      syncSticky();
    }

    /* ---------- Mobile gallery dashes ---------- */
    var list = root.querySelector('.product__media-list');
    var mediaWrap = root.querySelector('.product__media-wrapper');
    if (list && mediaWrap) {
      var dashes = document.createElement('div');
      dashes.className = 'e-dashes';
      dashes.setAttribute('aria-hidden', 'true');
      mediaWrap.appendChild(dashes);

      var visibleItems = function () {
        return Array.prototype.filter.call(list.children, function (li) {
          return li.offsetParent !== null || li.getClientRects().length;
        });
      };
      var build = function () {
        var n = visibleItems().length;
        dashes.innerHTML = n > 1 ? new Array(n + 1).join('<span></span>') : '';
        update();
      };
      var update = function () {
        var w = list.clientWidth || 1;
        var idx = Math.round(list.scrollLeft / w);
        Array.prototype.forEach.call(dashes.children, function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      };
      list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      new MutationObserver(build).observe(list, { childList: true });
      window.addEventListener('resize', build);
      build();
    }
  }

  function initAll() {
    document.querySelectorAll('product-info.emporium-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-run when the section is re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
